import { useEffect, useState } from 'react';
import liff from '@line/liff';
import { LIFF_ID } from '../../config';

export function useLiffInit({ enabled = true } = {}) {
  const [liffLoaded, setLiffLoaded] = useState(false);

  useEffect(() => {
    if (!enabled) return;
    const initializeLiff = async () => {
      try {
        await liff.init({ liffId: LIFF_ID });
        setLiffLoaded(true);
      } catch (error) {
        console.error('liff init error', error.message);
      }
    };

    initializeLiff();
  }, [enabled]);

  return {
    liffLoaded
  };
}
